<form-control
  [group]="group"
  [config]="dropdownConfig"
  [control]="group.get(config.prop)"
>
</form-control>

@if (otherControl) {
  <form-control
    [group]="group"
    [config]="otherTextConfig"
    [control]="otherControl"
  >
  </form-control>
}
